@if (customer) {
  <div class="card card-nb h-100 hover-effect" (click)="showDetails()" >
    <div class="card-body pb-0">
      <div class="row mb-2">
        <div class="col d-flex justify-content-between align-items-start">
          <div class="highlighted font-weight-bold huline" (click)="showDetails()">
            <span>{{customer.name}}</span>
          </div>
          <div class="badge-icon-container">
            <i class="fas fa-cloud red icon-size-bigger"></i>
            <span class="badge rounded-pill" style="background-color: red; color: white;">{{ customer.appliance_ids.length }}</span>
          </div>
        </div>
      </div>
      <div class="row subinformations">
        <div class="col-10">
          <div>{{customer.street}}&nbsp;{{customer.street2}}</div>
          <div>{{customer.zip}}&nbsp;{{customer.city}}</div>
          <div>{{customer.country.code}}&nbsp;{{customer.country.name}}</div>
        </div>
        <div class="col-2">
          <div class="d-flex align-items-end flex-column h-100">
            <div class="mb-auto">
              &nbsp;
            </div>
            <div>
              <ng-content></ng-content>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
